import { fetcher } from '@commenda/utils';

export async function confirmEnvelopeSent(
  envelopeId: string
): Promise<Response> {
  return fetcher(`e-signature/envelopes/${envelopeId}/confirm-sent`, {
    method: 'POST',
    body: {},
  });
}
